import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { Grid } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import { Popover } from '@blueprintnyc/bpnyc-common';
import { Sort } from '@blueprintnyc/bpnyc-common-admin';
import Filter from 'components/Filter';

const MediaToolBar = props => {
	const { viewType, handleMediaFilter, sortOrder, changeSortOrder, setViewType, fileTypes } = props;

	const filterOptions = [
		{ 'name': 'PDF', 'id': 'pdf' },
		{ 'name': 'Image', 'id': 'image' },
		{ 'name': 'Video', 'id': 'video' },
	];

	const sortOptions = [
		{ name: 'Alphabetically', id: 'alpha' },
		{ name: 'Last Added', id: 'lastAdded' },
		{ name: 'Last Updated', id: 'lastUpdated' },
		{ name: 'Type', id: 'type' },
	];

	return (
		<div className="material-toolbar">
			<div className="material-sort-and-filter">
				<div className="material-filter">
					<Filter
						data={filterOptions}
						selected={fileTypes}
						onChange={handleMediaFilter}
						multiselect={true}
					/>
				</div>
				<div className="material-sort">
					<Sort options={sortOptions} selected={sortOrder} onChange={changeSortOrder} />
				</div>
			</div>
			<div className="material-view">
				<Popover title="List View">
					<div className={`view-type${viewType === 'listView' ? ' selected' : ''}`}>
						<UnorderedListOutlined onClick={() => setViewType('listView')} />
					</div>
				</Popover>
				<Popover title="Thumbnail View">
					<div className={`view-type${viewType === 'gridView' ? ' selected' : ''}`}>
						<span className="grid-icon">
							<Grid onClick={() => setViewType('gridView')} />
						</span>
					</div>
				</Popover>
			</div>
		</div>
	);
};

export default MediaToolBar;
